import { z } from 'zod';

const STORAGE_KEY = 'qmd.asyncVisit.skipStartConfirmation';
const schema = z.boolean();

/** Whether the provider opted out of the async-visit start confirmation. */
export const getSkipStartConfirmation = (): boolean => {
  try {
    const raw: unknown = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? 'false');
    const parsed = schema.safeParse(raw);
    return parsed.success ? parsed.data : false;
  } catch {
    // localStorage unavailable or corrupt (e.g. private mode) — show the confirmation.
    return false;
  }
};

export const setSkipStartConfirmation = (value: boolean): void => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  } catch (error) {
    console.warn('Failed to persist start-confirmation preference', error);
  }
};
